import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import axios from "axios";
import image from "../../assets/images/dummy_pic.jpeg"; // Default image
import { BaseURL, uniqueToken } from "../../api/DataApis";
import { GpsBaseURL } from "../../api/DataApis";
import './User.css'; // Custom styles

const View = () => {
  document.title = "Corporate | View";
  const [Users, setUsers] = useState({});
  const [loading, setLoading] = useState(true); // State to manage loader
  const params = useParams();
  const UserID = params.cid;

  const fetchData = async () => {
    const apiEndpoint = `${GpsBaseURL}/product/${UserID}`;

    try {
      let res = await axios.get(apiEndpoint, {
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          Authorization: `Bearer ${uniqueToken}`,
        }
      });
      if (res && res.data && res.data.data && res.data.data.length > 0) {
        setUsers(res.data.data[0]);
      } else {
        console.error("No user data found");
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    } finally {
      setLoading(false); // Stop loader when data is fetched
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="container my-5">
      <div className="card shadow-lg p-4">
        {loading ? (
          <div className="text-center">
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        ) : (
          <>
            {/* Page Title */}
            <h1 className="page-title text-center mb-4">Product Details</h1>

            {/* Profile Image and Basic Info */}
            <div className="profile-header text-center">
              <img
                className="profile-image rounded-circle mb-4"
                src={Users?.product_image ? Users?.product_image : image}
                alt="Profile"
                style={{ width: '150px', height: '150px', objectFit: 'cover', border: '3px solid #ddd' }}
              />
              <h5 className="user-name mb-1">{Users?.title}</h5>
              {/* <p className="user-role">Class:&nbsp; <b>{Users?.userType}</b></p> */}
            </div>

            {/* Personal Information Section */}
            <div className="profile-info mt-4">
              <h3 className="section-title">Product Information</h3>
              <div className="row">
              <div className="col-md-6 mb-3">
  <p><strong>Title: &nbsp;</strong>{Users?.title}</p>
  <p><strong>Price: </strong>+{Users?.phone_code}-{Users?.price}</p>
  <p><strong>Is Featured: &nbsp;</strong>{Users?.is_featured}</p>
  <p><strong>Status: &nbsp;</strong>{Users?.status}</p>
  <p><strong>Created By: &nbsp;</strong>{Users?.createdBy?.name}({Users?.createdBy?.email})</p>
</div>
<div className="col-md-6 mb-3">
  <p><strong>Description: </strong> {Users?.description}</p>
  <p><strong>Stock: </strong> {Users?.stock}</p>
  <p><strong>Created at: &nbsp;</strong>{Users?.createdAt}</p>

  <p><strong>Updated Date: &nbsp;</strong>{Users?.updatedAt}</p>
  <p>
  <strong>Updated By:&nbsp; </strong>
  {Users?.updated_by?.[0]?.name ? `${Users.updated_by[0].name} (${Users.updated_by[0].email})` : "N/A"}
</p>
</div>

             
              
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default View;
